@if (data.entity) {

<ui-entity-note [entity]="data.entity" (close)="close()"></ui-entity-note>

}